import { Typography, styled } from '@mui/material'

const Message = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  lineHeight: '1.5em',
}))

export default Message
